import createIcon from '../../createIcon';

/**
 * @component @name Diamond
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMTU5OSAzLjQ0OTIySDExLjgzOTlMOS4yMDk4OCA4LjY5OTIySDE0Ljc4OTlMMTIuMTU5OSAzLjQ0OTIyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjQ1OTkgOC42OTkyMkgyMS42MTk5TDE4Ljk5OTkgMy40NDkyMkgxMy44Mzk5TDE2LjQ1OTkgOC42OTkyMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS4zNzk5IDEwLjE5OTJIMTIuNzQ5OVYyMC41NDkyTDIxLjM3OTkgMTAuMTk5MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS4yNDk5IDIwLjU0OTJWMTAuMTk5MkgyLjYxOTg4TDExLjI0OTkgMjAuNTQ5MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjUzOTg4IDguNjk5MjJMMTAuMTU5OSAzLjQ0OTIySDQuOTk5ODhMMi4zNzk4OCA4LjY5OTIySDcuNTM5ODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Diamond = createIcon('Diamond', [
  [
    'path',
    { d: 'M12.1599 3.44922H11.8399L9.20988 8.69922H14.7899L12.1599 3.44922Z', key: 'o00s1q' },
  ],
  [
    'path',
    { d: 'M16.4599 8.69922H21.6199L18.9999 3.44922H13.8399L16.4599 8.69922Z', key: '1fdwq9' },
  ],
  ['path', { d: 'M21.3799 10.1992H12.7499V20.5492L21.3799 10.1992Z', key: '1rqene' }],
  ['path', { d: 'M11.2499 20.5492V10.1992H2.61988L11.2499 20.5492Z', key: '1j7zjh' }],
  [
    'path',
    { d: 'M7.53988 8.69922L10.1599 3.44922H4.99988L2.37988 8.69922H7.53988Z', key: '1gqwlr' },
  ],
]);

export default Diamond;
